export const applyArrayTo =
  <T extends any[], U>(project: (...args: T) => U) =>
  (array: T): U =>
    project(...array);
